// extracted by mini-css-extract-plugin
module.exports = {"configContainer":"classConfig_configContainer__kkAyc","checkboxesContainer":"classConfig_checkboxesContainer__3_7hD","checkbox":"classConfig_checkbox__1JtgA"};